export enum EPanelActionType {
  INIT_PANEL_SETTINGS = 'panel/INIT_PANEL_SETTINGS',
  SET_MESH_ACTIVE_PANEL = 'panel/SET_MESH_ACTIVE_PANEL',
  SET_GEOMETRY_ACTIVE_PANEL = 'panel/SET_GEOMETRY_ACTIVE_PANEL',
  SET_MESH_QUERY_PANEL = 'panel/SET_MESH_QUERY_PANEL',
  REMOVE_QUERYDEF_FROM_PANEL_SETTINGS = 'panel/REMOVE_QUERYDEF_FROM_PANEL_SETTINGS',
}
